import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <footer className='footer'>
            Copyright &#169; 2023 Rahul Rana. All Rights recieved.
        </footer>
    );
}

export default Footer;